import { Plus, Trash2 } from 'lucide-react';
import type { LeadFormDocumentRequirement } from '../../lib/types/leadForm';

/**
 * L'elenco dei documenti, riga per riga: nome e "obbligatorio".
 * Lo stesso editor serve per una richiesta al volo e per un modello salvato.
 */

export function nuovaVoce(): LeadFormDocumentRequirement {
  return { id: crypto.randomUUID(), label: '', required: true };
}

export const inputDocumentiCls =
  'w-full px-2.5 py-1.5 text-sm border border-[rgba(55,53,47,0.16)] dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-[#37352F] dark:text-white focus:outline-none focus:border-[#337EA9]';

interface Props {
  voci: LeadFormDocumentRequirement[];
  onChange: (voci: LeadFormDocumentRequirement[]) => void;
}

export default function ElencoDocumentiEditor({ voci, onChange }: Props) {
  const aggiorna = (idx: number, parziale: Partial<LeadFormDocumentRequirement>) =>
    onChange(voci.map((v, i) => (i === idx ? { ...v, ...parziale } : v)));

  return (
    <div className="space-y-2">
      {voci.map((voce, idx) => (
        <div key={voce.id} className="flex items-center gap-2">
          <input
            className={inputDocumentiCls}
            value={voce.label}
            placeholder="Es. Carta d'identità"
            onChange={(e) => aggiorna(idx, { label: e.target.value })}
          />
          <label className="flex flex-shrink-0 items-center gap-1.5 text-xs text-[#787774]">
            <input
              type="checkbox"
              checked={voce.required}
              onChange={(e) => aggiorna(idx, { required: e.target.checked })}
              className="rounded border-gray-300"
            />
            obbligatorio
          </label>
          <button
            type="button"
            onClick={() => onChange(voci.length === 1 ? [nuovaVoce()] : voci.filter((_, i) => i !== idx))}
            className="flex-shrink-0 p-1 text-gray-400 hover:text-red-500"
            title="Rimuovi"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={() => onChange([...voci, nuovaVoce()])}
        className="flex items-center gap-1 text-xs text-[#337EA9] hover:underline"
      >
        <Plus className="h-3.5 w-3.5" />
        Aggiungi documento
      </button>
    </div>
  );
}
